export default "/images/briefcase.svg?21248a068c385cec74542746ea8c5e8c";